import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { useMemo, useState } from 'react';
import { Slices } from '@yoweb/prismic-slicemachine/components/Slices';
import { EmployersTemplate } from '@yoweb/prismic-slicemachine/customtypes/PageTemplateEmployers';
import { EmployersForm } from '@store/components/Employers/EmployersForm';
import { EmployerLayout } from '@store/components/layouts/EmployerLayout';
import { WhitePaperModal } from '@store/components/Employers/WhitePaperModal';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Employers page with slices.
 */
var EmployersPage = function EmployersPage(_ref) {
  var slices = _ref.slices,
      meta = _ref.meta;

  var _useState = useState(false),
      modalOpen = _useState[0],
      setModalOpen = _useState[1];

  var navItems = useMemo(function () {
    return slices.map(function (slice) {
      var _slice$primary, _slice$primary2;

      return {
        // @ts-ignore Get these fields if the slice has them, most won't
        sliceId: slice === null || slice === void 0 ? void 0 : (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.navId,
        // @ts-ignore Get these fields if the slice has them, most won't
        display: slice === null || slice === void 0 ? void 0 : (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.navLabel
      };
    }).filter(function (navItem) {
      return navItem.sliceId && navItem.display;
    });
  }, [slices]);

  var handleClose = function handleClose() {
    setModalOpen(false);
  };

  var openModal = function openModal() {
    setModalOpen(true);
  };

  slices.forEach(function (slice) {
    if (slice.slice_type === 'vertical_scroll_carousel_slice' && slice.primary.useWhitePaperCta) {
      slice.primary.whitePaperModal = /*#__PURE__*/_jsx(WhitePaperModal, {
        onClose: handleClose,
        isOpen: modalOpen
      });
      slice.primary.openModal = openModal;
    }
  });
  return /*#__PURE__*/_jsx(EmployerLayout, {
    withTransparentHeader: true,
    navItems: navItems,
    children: /*#__PURE__*/_jsx(Slices, {
      slices: slices,
      meta: meta,
      template: EmployersTemplate,
      injectables: _defineProperty({}, slices.length, /*#__PURE__*/_jsx(EmployersForm, {}))
    })
  });
};

EmployersPage.layout = {
  type: 'none'
};
export var __N_SSP = true;
export default _withSuperJSONPage(EmployersPage);